import { Component, OnInit, Input } from '@angular/core';
import { ApprovalsMenuItem } from '@core/models/menu-item.model';

// custom types
import { approvalsDefaultItem } from './approvals-status.menu';

@Component({
  selector: 'app-approvals-status-menu-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class ApprovalsStatusMenuComponent implements OnInit {
  @Input() status: ApprovalsMenuItem[];

  public approvalsStatusMenu: ApprovalsMenuItem[] = [];
  public match: boolean = true; // to not match full uls on vetrical tabs

	constructor(
        // public appSrv: AppService,
        // private approvalsSrv: ApprovalsService
    ){}

	ngOnInit(){
      if(this.status)
          this.updateMenu()
  }
  // not used
  onMenuClick(item: ApprovalsMenuItem ){
      // console.log(" LISTEN TO NEW WORKFLOW =====> ",item);

      // TODO: what should do HERE ???
      // this.dashSrv.setCurrentWorkflow(+item.workflow);
  }

  protected updateMenu(){
    // set ordered workflows in left menu
    this.approvalsStatusMenu = this.status;
         
  }
}
